import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/hooks/useAuth";
import { UserMenu } from "@/components/auth/UserMenu";
import { languages, type Language } from "@/i18n";

export function Header() {
  const { t, i18n } = useTranslation();
  const { isAuthenticated, isLoading } = useAuth();

  const toggleLanguage = () => {
    const newLang = i18n.language === "en" ? "he" : "en";
    i18n.changeLanguage(newLang);
  };

  const currentLang = i18n.language as Language;

  return (
    <header className="fixed start-0 top-0 z-50 w-full bg-white/80 backdrop-blur-md" style={{ isolation: 'isolate' }}>
      <div className="container mx-auto flex items-center justify-between px-4 py-3">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-600 text-xl font-bold text-white">
            B
          </div>
          <span className="text-xl font-bold text-gray-900">BYK</span>
        </Link>

        {/* Navigation */}
        <nav className="hidden items-center gap-6 md:flex">
          <Link
            to="/catalog"
            className="text-sm font-medium text-gray-600 hover:text-primary-600"
          >
            {t("nav.catalog", "Catalog")}
          </Link>
          <Link
            to="/about"
            className="text-sm font-medium text-gray-600 hover:text-primary-600"
          >
            {t("nav.about", "About")}
          </Link>
        </nav>

        {/* Actions */}
        <div className="flex items-center gap-3">
          {/* Language Switcher */}
          <button
            onClick={toggleLanguage}
            className="rounded-lg px-3 py-2 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-100"
          >
            {languages[currentLang === "en" ? "he" : "en"].name}
          </button>

          {/* Auth */}
          {isLoading ? (
            <div className="h-8 w-8 animate-pulse rounded-full bg-gray-200" />
          ) : isAuthenticated ? (
            <UserMenu />
          ) : (
            <Link
              to="/login"
              className="rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary-700"
            >
              {t("nav.signIn", "Sign In")}
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
